import { returnShipmentStatusLabels, shipmentStatusLabels, shippingLabelTypes } from '@reveni-io/reveni-ui'

export const scenarioShipmentTypeOptions = [
  { value: shippingLabelTypes.shipment, label: 'Envío' },
  { value: shippingLabelTypes.return, label: 'Devolución' },
]

export const statusLabelsByShipmentType = {
  [shippingLabelTypes.shipment]: shipmentStatusLabels,
  [shippingLabelTypes.return]: returnShipmentStatusLabels,
}

export const statusFieldLabelsByShipmentType = {
  [shippingLabelTypes.shipment]: 'Estado del envío #{{number}}',
  [shippingLabelTypes.return]: 'Estado de la devolución de envío #{{number}}',
}
